import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import { CheckRow, MobileCard2 } from "./Section1";

export const Settle = ({
  refs,
}: {
  refs: {
    payment: React.RefObject<HTMLDivElement>;
    payService: React.RefObject<HTMLDivElement>;
    settle: React.RefObject<HTMLDivElement>;
    merchant: React.RefObject<HTMLDivElement>;
    sales: React.RefObject<HTMLDivElement>;
  };
}) => {
  const isMobile = useResponsiveMobile(900);
  return (
    <div
      id="payout-service"
      className="flex flex-col gap-[80px] md:gap-20 xl:px-0"
      ref={refs.settle}
    >
      <div className="flex flex-col gap-[32px] md:gap-10">
        <div className="flex flex-col gap-3">
          <h1 className="font-bold text-[36px] md:text-display flex items-center gap-[4px]">
            {isMobile && (
              <img
                width="48"
                height="48"
                alt="정산 서비스"
                src="/assets/images/icon/sidenav_settle.png"
              />
            )}
            정산 서비스
          </h1>
          <span className="font-semibold text-[18px] md:text-[20px] text-[#0079FF]">
            분산된 라이선스 문제 없이도 {isMobile ? <br /> : ""}안정적인 정산 업무가 가능합니다
          </span>
        </div>
        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58] leading-relaxed">
          품(Poom)은 결제와 정산이 필요한 B2B 플랫폼 {isMobile ? <br /> : ""}기업을 위해 정산
          서비스를 제공하고 있습니다.
        </span>
      </div>

      <div className="flex flex-col gap-[80px] md:gap-[100px]">
        <div className="flex flex-col gap-[80px] md:gap-10 md:gap-15">
          {/* 정산 서비스 */}
          <div className="flex flex-col md:flex-row gap-6 md:gap-10 md:items-center">
            <div className="flex flex-col gap-[12px]  md:gap-8 md:w-1/2">
              {/* 정산서비스 뱃지 (모바일 전용) */}
              {isMobile && (
                <div className="rounded-full px-[12px] py-[4px] border-[1px] border-[#0079FF] w-fit">
                  <span className="font-normal text-[#0079FF] text-[16px]">정산서비스</span>
                </div>
              )}

              <div className="flex flex-col gap-8 md:gap-10">
                <div className="flex md:flex-col  gap-2">
                  <img
                    width={isMobile ? 24 : 48}
                    height={isMobile ? 24 : 48}
                    src="/assets/images/icon/electronic_bulb_blue.png"
                    alt="electronic_bulb"
                  />
                  <span className="font-bold text-[20px] md:text-display3_1  text-[#121319]">
                    {isMobile ? (
                      <> 안정적인 정산 업무가 가능해요</>
                    ) : (
                      <>
                        {" "}
                        안정적인 <br />
                        정산 업무가 가능해요
                      </>
                    )}
                  </span>
                </div>
              </div>

              {/* 정산 서비스 설명 */}
              <div className="flex flex-col gap-[32px]">
                <span className="font-normal text-[16px] md:text-[20px] text-[#4D4F58] md:text-[#121319] leading-relaxed">
                  {isMobile ? (
                    <>
                      플랫폼이 직접 PG 역할을 수행하지 않아도, <br />
                      가맹점·입점사·영업대행사 등 다양한 파트너에게 안정적 <br />
                      으로 정산 업무를 처리할 수 있습니다
                    </>
                  ) : (
                    <>
                      플랫폼이 직접 PG 역할을 수행하지 않아도, 가맹점·입점사·영업대행사 등 다양한
                      파트너에게 안정적으로 정산 업무를 처리할 수 있습니다
                    </>
                  )}
                </span>

                <span className="font-normal text-[16px] md:text-base text-[#878C96] md:text-[#4D4F58] leading-relaxed">
                  {isMobile ? (
                    <>
                      여러 PG사의 분산된 정산 과정을 자동화하고, <br /> 고객사의 사업 구조에 맞춘
                      맞춤형 정산 주기와 조건 설정을 지원합니다.
                    </>
                  ) : (
                    <>
                      여러 PG사의 분산된 정산 과정을 자동화하고, 고객사의 사업 구조에 맞춘 맞춤형
                      정산 주기와 조건 설정을 지원합니다.
                    </>
                  )}
                </span>
              </div>
            </div>

            {/* 정산 서비스 이미지 */}
            <div className="md:w-1/2 w-full flex">
              <img
                src={
                  isMobile
                    ? "/assets/images/introduction/eg5_mobile.png"
                    : "/assets/images/introduction/eg5.png"
                }
                className="md:flex-1"
                alt="eg"
              />
            </div>
          </div>

          {/* 부가 서비스 */}
          <div className="flex flex-col md:flex-row gap-[80px] w-full">
            {/* 부가 서비스 01 */}
            <div className="flex flex-col gap-[24px] md:justify-between md:w-1/2">
              <div className="flex flex-col gap-[32px] md:gap-10">
                {/* 부가 서비스 뱃지 */}
                <div className="rounded-full px-[12px] py-[4px] border-[1px] border-[#0079FF] w-fit">
                  <span className="font-normal text-[#0079FF] text-[16px]">부가서비스 01</span>
                </div>

                {/* 부가 서비스 설명 */}
                <div className="flex flex-col gap-[12px] md:gap-10">
                  <span className="font-bold text-[18px] md:text-display3_1 leading-[1.5]">
                    오늘 매출을 오늘 현금으로, <br /> 비즈니스에 활력을 더하는{" "}
                    <span className="text-[#0079FF]">선·실시간 정산</span>
                  </span>

                  <span className="font-normal text-[#4D4F58] text-[16px] md:text-xl leading-relaxed">
                    매출 발생 즉시 정산금을 지급받아 자금 정체를 해결하세요. 가맹점의 자금난을
                    해소하고 본사와의 상생을 돕는 품(Poom)만의 빠른 정산 시스템입니다
                  </span>
                </div>
              </div>

              {/* 부가 서비스 이미지 */}
              <img
                src="/assets/images/introduction/additional1.svg"
                alt="eg"
                className="w-full h-auto"
              />
            </div>

            {/* 부가 서비스 02 */}
            <div className="flex flex-col gap-[24px] md:justify-between md:w-1/2">
              <div className="flex flex-col gap-[32px] md:gap-10">
                {/* 부가 서비스 뱃지 */}
                <div className="rounded-full px-[12px] py-[4px] border-[1px] border-[#0079FF] w-fit">
                  <span className="font-normal text-[#0079FF] text-[16px]">부가서비스 02</span>
                </div>

                {/* 부가 서비스 설명 */}
                <div className="flex flex-col gap-[12px] md:gap-10">
                  <span className="font-bold text-[18px] md:text-display3_1 ">
                    미래 매출을 {isMobile ? "" : <br />}
                    가치로 바꾸는 <span className="text-[#186BE8]">매출약정 지원</span>
                  </span>
                  <span className="font-normal text-[16px] md:text-xl leading-relaxed text-[#4D4F58]">
                    축적된 거래 데이터를 기반으로 미래 매출의 가치를 인정받아 사업 확장 자금을
                    사전에 확보하세요. 비즈니스 가치만으로 자금 운용이 가능해집니다.
                  </span>
                </div>
              </div>

              {/* 부가 서비스 이미지 */}
              <img src="/assets/images/introduction/additional2.svg" alt="eg" className="w-full" />
            </div>
          </div>
        </div>

        {/* 카드 섹션 */}
        <div className="flex flex-col gap-6 md:gap-20">
          <div className="flex flex-col gap-[8px] md:gap-6">
            <h2 className="font-bold text-[18px] md:text-display2 text-[#121319]">
              품에서는 다양한 정산 서비스를 제공합니다
            </h2>
            <span className="font-normal text-[#4D4F58] text-[16px] md:text-heading1_2">
              다양한 결제 데이터를 표준화하여 조회할 수 있어요
            </span>
          </div>

          <div className="flex flex-col gap-[30px]">
            <div className="md:grid md:grid-cols-[repeat(auto-fit,minmax(330px,1fr))] md:gap-[30px] flex flex-col gap-3">
              {/* 카드 01 */}
              <div
                className="flex-1 flex flex-col rounded-[24px] md:h-[394px] "
                style={{
                  //  회색 보더(기본 유지)
                  boxShadow: "inset 0 0 0 1px #DDE0E6",

                  //  그라데이션을 border 영역에만 얹기 위한 세팅
                  border: "3px solid transparent",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box, border-box",

                  //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                  backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 270deg,
            #0079FF 60deg,
            #00FF44 100deg,
     
            transparent 90deg,
            transparent 360deg
          )
        `,
                }}
              >
                <div className="flex flex-col p-6 items-center justify-center md:justify-start md:px-10 md:py-[60px] md:h-full">
                  <div className="flex flex-col gap-[24px] items-start w-full">
                    <img
                      src="/assets/images/introduction/settlement.png"
                      alt="icon1"
                      width={56}
                      height={56}
                    />

                    <div className="flex flex-col gap-[12px] md:gap-5">
                      <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 ">
                        정산 서비스
                      </span>
                      <CheckRow
                        content={
                          <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                            가맹점·입점사·영업대행에게 {isMobile ? "" : <br />} 정산 업무 처리
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* 카드 02 */}
              {isMobile ? (
                <MobileCard2
                  src="/assets/images/introduction/automation.png"
                  text={
                    <>
                      거래대사, 보고서 작성, 지급대행 등 <br />
                      반복 업무 자동 처리
                    </>
                  }
                  title="정산 업무 자동화"
                />
              ) : (
                <div
                  className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 320deg,
                #FFC300 10deg,
                #00FF44 30deg,
            #0079FF 40deg,
        
            transparent 90deg,
            transparent 360deg
          )
        `,
                  }}
                >
                  <div className="flex flex-col md:justify-start md:px-10 md:py-[60px] h-full">
                    <div className="flex flex-col gap-[24px] items-start w-full">
                      <img
                        src="/assets/images/introduction/automation.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-[12px] md:gap-5">
                        <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                          정산 업무 자동화
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                              거래대사, 보고서 작성, 지급대행 등 반복 업무 자동 처리
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 카드 03 */}
              {isMobile ? (
                <MobileCard2
                  src="/assets/images/introduction/setting_condition.png"
                  text={
                    <>
                      사업자 유형에 따라 <br />
                      다양한 정산 주기·조건을 유연하게 설정
                    </>
                  }
                  title="맞춤형 정산 주기 및 조건 설정"
                />
              ) : (
                <div
                  className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 360deg,
            #0079FF 0deg,
            #00FF44 90deg,
            #FFC300 110deg,
            transparent 90deg,
            transparent 360deg
          )
        `,
                  }}
                >
                  <div className="flex flex-col md:justify-start md:px-10 md:py-[60px] h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/setting_condition.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-5">
                        <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                          맞춤형 정산 주기 <br />및 조건 설정
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[18px] text-[#4D4F58]">
                              사업자 유형에 따라
                              <br />
                              다양한 정산 주기·조건을 유연하게 설정
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 카드 04 */}
              {isMobile ? (
                <MobileCard2
                  src="/assets/images/introduction/linking_financing.png"
                  text={
                    <>
                      가맹점 매출을 담보로 선지급 후 <br />
                      정산 시 상환하는 구조로 자금 유동성 <br />
                      확보 및 파트너사의 수수료 수익 창출
                    </>
                  }
                  title="파이낸싱(팩토링) 연계"
                />
              ) : (
                <div
                  className="flex-1 flex flex-col rounded-[24px] h-[394px] "
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 180deg,
            #0079FF 30deg,
            #00FF44 90deg,
            #FFC300 110deg,
            transparent 90deg,
            transparent 360deg
          )
        `,
                  }}
                >
                  <div className="flex flex-col md:justify-start md:px-10 md:py-[60px] h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/linking_financing.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-5">
                        <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                          파이낸싱(팩토링) {!isMobile && <br />} 연계
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[18px] text-[#4D4F58]">
                              가맹점 매출을 담보로 선지급 후 <br />
                              정산 시 상환하는 구조로 자금 유동성 확보 {isMobile && <br />}및
                              파트너사의 수수료 수익 창출
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 카드 05 */}
              {isMobile ? (
                <MobileCard2
                  src="/assets/images/introduction/minimize_risk.png"
                  text={
                    <>
                      자동화된 정산 흐름과 이상 거래 감지 <br />
                      기능으로 사고율 감소 및 운영 안정성 확보
                    </>
                  }
                  title="리스크 최소화"
                />
              ) : (
                <div
                  className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
        conic-gradient(
      from 140deg,
    
      #0079FF 1deg 15deg,
      #00FF44 25deg 60deg,
      #FFC300 65deg 75deg,
    
      transparent 38deg 360deg
    )
        `,
                  }}
                >
                  <div className="flex flex-col md:justify-start md:px-10 md:py-[60px] h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/minimize_risk.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-5">
                        <span className="h-[94px] font-bold text-[20px] md:text-display3_1">
                          리스크 최소화
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[18px] text-[#4D4F58]">
                              자동화된 정산 흐름과 <br />
                              이상 거래 감지 기능으로 <br /> 사고율 감소 및 운영 안정성 확보
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* 카드 06 */}
              {isMobile ? (
                <div
                  className="flex-1 flex flex-col rounded-[24px] md:h-[394px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 90deg,
            #00FF44 1deg,
             #0079FF 90deg,
     
            transparent 10deg,
            transparent 360deg
          )
        `,
                  }}
                >
                  <div className="flex flex-col p-6 items-center justify-center md:p-10 md:h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/monitor_flow.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-3 md:gap-5">
                        <span className="md:h-[94px] font-bold text-[18px] md:text-display3_1 ">
                          정산 흐름 모니터링
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                              실시간으로 정산 예정 금액, 지급 내역, 수수료 계산 결과를 확인 가능
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="flex-1 flex flex-col rounded-[24px] h-[394px]"
                  style={{
                    //  회색 보더(기본 유지)
                    boxShadow: "inset 0 0 0 1px #DDE0E6",

                    //  그라데이션을 border 영역에만 얹기 위한 세팅
                    border: "3px solid transparent",
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",

                    //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
                    backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 90deg,
            #0079FF 60deg,
            #00FF44 100deg,
            #FFC300 110deg,
            transparent 90deg,
            transparent 360deg
          )
        `,
                  }}
                >
                  <div className="flex flex-col md:justify-start md:px-10 md:py-[60px] h-full">
                    <div className="flex flex-col gap-6 items-start w-full">
                      <img
                        src="/assets/images/introduction/monitor_flow.png"
                        alt="icon1"
                        width={56}
                        height={56}
                      />

                      <div className="flex flex-col gap-5">
                        <span className="h-[94px] font-bold text-[20px] md:text-display3_1 ">
                          정산 흐름 모니터링
                        </span>
                        <CheckRow
                          content={
                            <span className="font-normal text-[18px] text-[#4D4F58]">
                              실시간으로 정산 예정 금액, 지급 내역, 수수료 계산 결과를 확인 가능
                            </span>
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
